"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { ReadMoreBlock } from "@/components/ReadMoreBlock";

export function ServicesClosingExpandable() {
  const t = useTranslations("servicesHub");
  const tContact = useTranslations("contact");

  return (
    <>
      <h2
        className="font-display text-2xl sm:text-3xl md:text-[clamp(1.75rem,3vw,2.5rem)] text-[var(--on-surface)] mb-5 tracking-tight"
        style={{ fontFamily: "var(--font-display)" }}
      >
        {t("closingTitle")}
      </h2>
      <ReadMoreBlock
        readFullHref="/contact"
        className="mb-10"
        collapsedContent={
          <p
            className="text-[var(--on-surface-variant)] max-w-lg leading-relaxed text-[1.0625rem] sm:text-lg"
            style={{ fontFamily: "var(--font-body)" }}
          >
            {t("closingTeaser")}
          </p>
        }
        expandedContent={
          <p
            className="text-[var(--on-surface-variant)] max-w-lg leading-relaxed text-[1.0625rem] sm:text-lg"
            style={{ fontFamily: "var(--font-body)" }}
          >
            {t("closingBody")}
          </p>
        }
      />
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-5 items-stretch sm:items-center">
        <Link
          href="/contact"
          className="inline-flex justify-center px-8 py-3.5 rounded-[var(--radius-sm)] bg-[var(--primary)] text-[var(--on-primary)] text-sm font-semibold tracking-tight hover:opacity-90 transition-opacity"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {tContact("pageTitle")}
        </Link>
        <Link
          href="/"
          className="inline-flex justify-center py-3.5 px-1 text-sm font-medium text-[var(--primary)] underline underline-offset-[5px] decoration-[color-mix(in_srgb,var(--primary)_35%,transparent)] hover:decoration-[var(--primary)] transition-colors"
          style={{ fontFamily: "var(--font-body)" }}
        >
          {t("backHome")}
        </Link>
      </div>
    </>
  );
}
